export default {
  PAD_BOTTOM: 'Add Bottom Padding',
};
